<template>
  <el-dialog
    :title="showDialog.text"
    :visible.sync="showDialog.type"
    width="80%"
    @close="diaClose"
    @opened="getData"
  >
    <div class="retrieve border">
      <div class="left">
        <div class="child">
          <span class="name">账号状态</span>
          <el-select v-model="formData.status" placeholder="请选择" size="small" clearable>
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="child" v-if="showType==='2'">
          <span class="name">管理员类型</span>
          <el-select v-model="formData.administratorType" placeholder="请选择" size="small" clearable>
            <el-option
              v-for="item in administratorTypeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <div class="child super_select">
          <span class="name">检索</span>
          <el-select
            v-if="showType==='1'"
            v-model="getSelect"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-if="showType==='2'"
            v-model="getSelect"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
        </div>
        <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      :header-cell-style="headerStyle"
      fit
      style="width: 100%"
      @selection-change="handleSelectionChange"
       v-loading="loading"
      element-loading-text="请求中......"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        v-for="(item,ind) in showTable"
        :key="ind"
        :prop="item.key"
        show-overflow-tooltip
        
        :label="item.name"
      ></el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </div>
    <div class="button_box">
      <el-button size="small" @click="backInform" class="retrievalBtn">取消</el-button>
      <el-button size="small" type="primary" @click="sureButton" class="retrievalBtn">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Object,
      default: function() {
        return { type: false, url: "" };
      }
    },
    portUrl: {
      type: String,
      default: ""
    },
    showType: {
      type: String,
      default: "1"
    },

    showTable: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      loading:false,
      diffText: "",
      statusList: [],
      administratorTypeList: [],
      formData: {
        currentPage: 1, //当前页
        pageSize: 10, //页条数
        property: null, //排序字段
        direction: null, //排序方式
        status: null,
        administratorType: null
      },
      defaultData: {
        currentPage: 1, //当前页
        pageSize: 10, //页条数
        property: null, //排序字段
        direction: null, //排序方式
        status: null,
        administratorType: null
      },
      totalSize: null, //总条数
      tableData: [],
      multipleSelection: [], //表格多选结果数组
      getValue: "",
      getSelect: "",
      options1: [
        {
          value: "id",
          label: "帐号ID"
        },
        {
          value: "userName",
          label: "帐号"
        },
        // {
        //   value: "realName",
        //   label: "姓名"
        // },
        {
          value: "companyName",
          label: "企业全称"
        },
        {
          value: "customerManager",
          label: "客户经理"
        }
      ],
      options2: [
        {
          value: "userName",
          label: "帐号"
        },
        {
          value: "realName",
          label: "姓名"
        }
      ] //检索下拉
    };
  },
  methods: {
    // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
    //  关闭重置
    diaClose() {
      this.getSelect = "";
      this.getValue = "";
      this.multipleSelection = [];
      this.tableData = [];
      this.formData = Object.assign({}, this.defaultData);
    },
    //表格选择事件
    handleSelectionChange(val) {
      if (val.length === 0) {
        this.diffText = "";
      } else if (val.length === 1) {
        this.diffText=val[0].companyName||val[0].realName
      } else {
        let text=this.showDialog.text.split("筛选")
        this.diffText = val.length+"个"+text[1]
      }
      this.multipleSelection = val;
    },
    getData() {
      // 存在请求地址
      this.loading = true
      if (this.showDialog.url) {
        let obj = Object.assign({}, this.formData);
        if (this.getSelect && this.getValue) {
          obj[this.getSelect] = this.getValue;
        }
        // debugger
        let met = "$axiosz";
        // if (this.showType !== "2") {
        //   // 如果不是管理员
        //   met = "$axiosz";
        // }
        this[met]
          .get(this.showDialog.url, {
            params: obj
          })
          .then(r => {
            if (r.code == 200) {
              this.tableData = r.data.content;
              this.totalSize = r.data.totalElements;
              this.loading = false
            } else {
              this.loading = false
              this.$alert(r.msg);
            }
          }).catch(e=>{
            this.loading = false
          })
      }
    },
    sureButton() {
      let arr = [];
      for (let item of this.multipleSelection) {
        arr.push(item.id);
      }
      arr = arr.join(",");
      this.$emit("sureData", {data:arr,text:this.diffText,name:this.showDialog.name});
      this.showDialog.type = false;
    },
    backInform() {
      this.showDialog.type = false;
    },
    //分页功能模块
    //切换每页显示条数
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    //切换页码
    handleCurrentChange(val) {
      this.formData.currentPage = val;
      this.getData();
    },
    //获取字典
    getDic: function() {
      this.$axiosz.get("backstage/sysDict/STATUS").then(r => {
        //账号状态
        if (r.code == 200) {
          this.statusList = r.data;
        }
      });
      this.$axiosz.get("backstage/sysDict/ADMINISTRATOR_TYPE").then(r => {
        //管理员类型
        if (r.code == 200) {
          this.administratorTypeList = r.data;
        }
      });
    }
  },
  created() {
    this.diffText = this.showDialog.text;
    this.getDic();
  }
};
</script>

<style lang="scss" scoped>
.staTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button_box {
  margin: 0 auto;
  //   margin-bottom: 20px;
  padding-top: 40px;
  // border-top: 1px solid #ececec;
  text-align: center;
}
</style>